exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-10px[data-v-8f926314]{padding:5px}", ""]);

// exports
